import type { MatSort } from '@angular/material/sort';
import { type IncidentSeverity } from '@models';

export function naturalSorting<T>(data: T[], sort: MatSort) {
  const active = sort.active;
  const direction = sort.direction;

  if (!active || direction === '') {
    return data;
  }

  return data.sort((a: any, b: any) => {
    let valueA = a[active];
    let valueB = b[active];

    if (sort.active === 'reported' || sort.active === 'resolved') {
      valueA = new Date(valueA).getTime() + '';
      valueB = new Date(valueB).getTime() + '';
    }

    if (sort.active === 'status') {
      const SEVERITY_ORDER = {
        'critical': 1,
        'major': 2,
        'minor': 3,
      };

      const severityA = a['severity'] as IncidentSeverity;
      const severityB = b['severity'] as IncidentSeverity;

      if (SEVERITY_ORDER[severityA] || SEVERITY_ORDER[severityB]) {
        const weightA = SEVERITY_ORDER[severityA] ?? 99;
        const weightB = SEVERITY_ORDER[severityB] ?? 99;

        return (weightA - weightB) * (direction === 'asc' ? 1 : -1);
      }
    }

    const valueAType = typeof valueA;
    const valueBType = typeof valueB;

    // Not available fields check
    if (valueA === undefined || valueB === undefined) return -1;

    // Object sorting
    if (valueAType === 'object') {
      valueA = JSON.stringify(valueA).toLowerCase();
    }
    if (valueBType === 'object') {
      valueB = JSON.stringify(valueB).toLowerCase();
    }

    // To string numbers
    if (valueAType !== valueBType) {
      if (valueAType === 'number') {
        valueA += ''.toLowerCase();
      }
      if (valueBType === 'number') {
        valueB += ''.toLowerCase();
      }
    }

    // natural sorting logic
    const comparatorResult = valueA.localeCompare(valueB, undefined, {
      numeric: true,
      sensitivity: 'base',
    });

    // asc / desc implementation
    return comparatorResult * (direction === 'asc' ? 1 : -1);
  });
}
